/*jshint esversion: 6 */

import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { firebaseConnect, getVal } from "react-redux-firebase";
import * as actionsAccountModal from "../actions/accountModalActions";
import * as actionsQuiz from "../actions/quizActions";
import { hasState } from "../helpers/stateHelper";
import { getQuiz, getQuestion, getTime } from "../helpers/wpHelper";
import {
  RANDOM_ERROR,
  QUIZ_LOADED,
  QUIZ_COMPLETE,
  QUIZ_STARTED,
  TIMER_TICK,
  REQUIRE_AUTH
} from "../actions/quizActions";
import { withTranslation } from "react-i18next";
import get from "lodash/get";
import { isVerified } from "../helpers/authHelper";
import CaQuestion from "./CaQuestion";
import CaQuizResult from "./CaQuizResult";
import CaTimer from "./CaTimer";
import CaQuizFeedback from "./CaQuizFeedback";
import * as quizHelper from "../helpers/quizHelper";
import * as pathSelectors from "../selectors/pathSelectors";
import * as quizSelectors from "../selectors/quizSelectors";
import * as dataSelectors from "../selectors/dataSelectors";
import { recalculateBadges } from "../helpers/computeBadges";
import _ from "lodash";

class CaQuizContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };

    this.onStartQuiz = this.onStartQuiz.bind(this);
    this.onAnswer = this.onAnswer.bind(this);
    this.onTick = this.onTick.bind(this);
  }

  componentDidMount() {
    this.loadQuiz(get(this.props, "data.quizId"));
  }

  componentDidUpdate(prevProps) {
    if (isVerified(prevProps.auth) != isVerified(this.props.auth)) {
      // console.log("!!!!!!!!!Auth state changed");
      this.loadQuiz(get(this.props, "data.quizId"));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (hasState(nextProps.quiz.state, QUIZ_STARTED)) {
      // Comment: Maybe this is a bit overkill? Maybe it's sufficient to just undo the loading here

      const newQuestion = quizSelectors.question(nextProps);
      const currentQuestion = quizSelectors.question(this.props);

      if (
        newQuestion &&
        (currentQuestion === undefined || newQuestion.id != currentQuestion.id)
      ) {
        this.setState({ loading: false });
      }
    } else if (
      hasState(nextProps.quiz.state, QUIZ_COMPLETE) &&
      !hasState(this.props.state, QUIZ_COMPLETE)
    ) {
      this.setState({ loading: false });
    }
  }

  initializeQuiz() {
    let questionPromise = getQuestion(this.getNextQuestionId());
    let timePromise = getTime();

    Promise.all([questionPromise, timePromise]).then(values => {
      this.setresult("startDate", values[1].data.time);
      this.props.startQuiz(
        values[0].data,
        values[1].data.time,
        quizSelectors.getTimelimit(this.props.quiz)
      );
    });
  }

  // Get points for quiz id!
  // FIXME: Move to a selector

  /**
   * Add points to all tags
   * @param {tags}
   * @param {points} The points to add to each tag
   * @returns {Promise}
   */
  setTagsForPoints(tags, points) {
    return new Promise((resolve, reject) => {
      let promises = [];

      tags.map(tag => {
        let pointsForTag = quizSelectors.getPointsForTag(this.props.user, tag);
        let pathForTag = pathSelectors.getPathForTag(tag, this.props.auth);

        promises.push(
          this.setFirebaseProperty(pathForTag, pointsForTag + points)
        );
      });

      Promise.all(promises).then(values => {
        resolve();
      });
    });
  }

  setNewAchievement(newValue, currentValue, valuePath) {
    return new Promise((resolve, reject) => {
      if (newValue > currentValue) {
        this.setFirebaseProperty(valuePath, newValue).then(values => {
          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  // Todo: this method and the one on top is almost identical
  setBestFinishingTimeForQuiz(currentFinishingTime, finishingTime) {
    return new Promise((resolve, reject) => {
      if (finishingTime < currentFinishingTime) {
        this.setFirebaseProperty(
          pathSelectors.getPathForQuizFinishingTime(this.props.quiz),
          finishingTime
        ).then(response => {
          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  setFirebaseProperty(property, value) {
    // console.log("firebase set property:", property, value);
    return this.props.firebase.set(property, value);
  }

  setresult(path, value) {
    return this.props.firebase.set(
      `${pathSelectors.getCurrentQuizPath(
        this.props.auth,
        this.props.quiz
      )}/${path}/`,
      value
    );
  }

  getNextQuestionId() {
    let index = this.props.quiz.questions.length;
    return this.props.data.questions[index];
  }

  //-------------------------------------------
  // Api
  //-------------------------------------------

  saveScore(points) {
    let path = pathSelectors.getPointsPath(this.props.auth, this.props.quiz);
    let currentPoints = quizSelectors.getPointsForCurrentQuiz(
      this.props.result,
      this.props.quiz
    );

    return this.setFirebaseProperty(path, currentPoints + points);
  }

  saveAnswer(answer, question) {
    let path = pathSelectors.getAnswerPath(
      this.props.auth,
      this.props.quiz,
      question
    );
    let answerObject = {
      type: quizHelper.getQuestionType(question),
      answer: answer
    };

    return this.setFirebaseProperty(path, answerObject);
  }

  loadQuiz(quizId) {
    getQuiz(quizId)
      .then(response => {
        if (
          isVerified(this.props.auth) &&
          !this.props.firebase.auth().currentUser.isAnonymous
        ) {
          this.props.quizVerified(response.data);
        } else if (get(this.props.data, "isExemptFromAuth")) {
          this.props.firebase
            .auth()
            .signInAnonymously()
            .then(() => {
              this.props.quizVerified(response.data);
            })
            .catch(err => console.log(err));
        } else {
          this.props.requireAuth(
            this.props.t("errors.auth_title"),
            this.props.t("errors.auth_content")
          );
        }
      })
      .catch(error => {
        console.error(error);
        this.props.randomError(
          this.props.t("errors.random_title"),
          this.props.t("errors.random_content")
        );
      });
  }

  /**
   * Load the next question from the data.questions prop
   */
  loadNextQuestion() {
    this.setState({ loading: true });

    document.querySelector(".QuizQuestion__body").focus();

    getQuestion(this.getNextQuestionId())
      .then(response => {
        this.props.questionLoaded(response.data);
      })
      .catch(error => {
        this.props.randomError(
          this.props.t("errors.random_title"),
          this.props.t("errors.random_content")
        );
      });
  }

  //------------------------------------------------------
  // Handlers
  //------------------------------------------------------

  onTick() {
    if (quizSelectors.getRemainingTime(this.props.quiz) === 0) {
      this.onQuizComplete();
    } else {
      this.props.tick(this.props.quiz);
    }
  }

  onQuizComplete() {
    this.setState({ loading: true });

    let currentMaxScore = quizSelectors.getMaxPointsForQuiz(
      this.props.general,
      this.props.quiz
    );
    let currentUserScore = quizSelectors.getUserPointsForQuiz(
      this.props.result,
      this.props.quiz
    );
    let setMaxPoints = this.setNewAchievement(
      currentUserScore,
      currentMaxScore,
      pathSelectors.getPathForQuizMaxPoints(this.props.quiz)
    );

    let getCurrentTime = getTime();

    // console.log("############", this.props.user, this.props.quiz, this.props.result[this.props.quiz.post.id]);

    let res = this.props.result[this.props.quiz.post.id];

    // Populate user answers with correct answer / tags
    this.props.quiz.questions.forEach(q => {
      let question = q["question-meta"];
      res.answers[q.id].correct = question.correct;
      res.answers[q.id].tags = question.tags;
    });

    // console.log("%%%% Quiz:", res);

    Promise.all([setMaxPoints, getCurrentTime])
      .then(values => {
        return this.setresult("endDate", values[1].data.time).then(
          () => values[1].data.time
        );
      })
      .then(response => {
        let userFinishingTime = quizSelectors.getFinishingTime(
          this.props.result,
          this.props.quiz
        );
        let bestFinishingTime = quizSelectors.getBestFinishingTime(
          this.props.general,
          this.props.quiz
        );

        const newPoints = this.props.result[this.props.quiz.post.id].points;
        const newScore =
          ((this.props.user && this.props.user.score) || 0) + newPoints;

        let tmpUser = _.clone(this.props.user || {});
        tmpUser.score = newScore;
        res.endDate = response;

        let setTopScore = this.setNewAchievement(
          newScore,
          quizSelectors.getCurrentMaxScore(this.props.general),
          pathSelectors.topScore()
        );

        return this.setBestFinishingTimeForQuiz(
          bestFinishingTime,
          userFinishingTime
        )
          .then(() =>
            this.setFirebaseProperty(
              pathSelectors.userScorePath(this.props.auth),
              newScore
            )
          )
          .then(() => recalculateBadges(res, tmpUser))
          .then(res => {
            let badges = {};
            _.forEach(this.props.result.badges, (v, k) => (badges[k] = true));

            let newBadges = {};

            res.forEach(b => {
              if (!badges[b]) {
                newBadges[b] = true;
                badges[b] = true;
              }
            });

            // console.log("New badges:", newBadges);

            let updateAction = [
              setTopScore,
              this.setFirebaseProperty(
                pathSelectors.getAllBadgesPath(this.props.auth),
                badges
              ),
              this.setFirebaseProperty(
                pathSelectors.getNewBadgesPath(this.props.auth),
                newBadges
              )
            ];

            return Promise.all(updateAction).then(r => res);
          });
      })
      .then(response => {
        this.props.quizComplete();
      });
  }

  onAnswer(question, answer) {
    this.setState({ loading: true });

    let promises = [];
    let points = quizHelper.getPointsForQuestion(question, answer);
    let tags = quizSelectors.getTagsForQuestion(question);

    promises.push(this.saveAnswer(answer, question));
    promises.push(this.saveScore(points));
    promises.push(this.setTagsForPoints(tags, points));

    Promise.all(promises)
      .then(values => {
        if (
          quizHelper.isLastQuestion(
            this.props.data.questions,
            this.props.quiz.questions
          )
        ) {
          // console.error("Last quiz");
          this.onQuizComplete();
        } else {
          // console.error("Load next question");
          this.loadNextQuestion();
        }
      })
      .catch(err => console.error(err)); // TODO: Catch error!
  }

  onStartQuiz() {
    if (!quizHelper.hasPreviouslyTakenQuiz(this.props)) {
      this.initializeQuiz();
    } else {
      this.props.randomError(
        this.props.t("errors.already_title"),
        this.props.t("errors.already_content")
      );
    }
  }

  //------------------------------------------------------
  // Render stuff?
  //------------------------------------------------------

  getResultContent(loggedIn) {
    if (loggedIn) {
      return {
        body: this.props.t("quiz_result.logged_in.body"),
        linkCta: this.props.t("quiz_result.logged_in.linkCta"),
        linkCallback: () => (window.location.href = "/profile")
      };
    } else {
      const { openCreateAccount } = this.props;

      return {
        title: this.props.t("quiz_result.not_logged_in.title"),
        body: this.props.t("quiz_result.not_logged_in.body"),
        submitCta: this.props.t("quiz_result.not_logged_in.submitCta"),
        submitCallback: () => openCreateAccount()
      };
    }
  }

  getContentByState(state) {
    if (hasState(state, REQUIRE_AUTH)) {
      return (
        <CaQuizFeedback
          title={this.props.quiz.error.title}
          bodyContent={this.props.quiz.error.body}
          noBackground={true}
          cta={"Sign in"}
          onClick={() => this.props.openCreateAccount()}
        />
      );
    }

    if (hasState(state, RANDOM_ERROR)) {
      return (
        <CaQuizFeedback
          title={this.props.quiz.error.title}
          bodyContent={this.props.quiz.error.body}
          noBackground={true}
        />
      );
    }

    // The quiz intro screen
    if (hasState(state, QUIZ_LOADED)) {
      return (
        <CaQuizFeedback
          title={get(this.props, "quiz.post.title.rendered")}
          bodyContent={get(this.props, "quiz.post.content.rendered")}
          featuredImage={get(
            this.props,
            "quiz.post.additional_meta.featuredImage[0]"
          )}
          cta={this.props.t("quiz_cta")}
          onClick={this.onStartQuiz}
        />
      );
    }

    // The quiz result
    if (hasState(state, QUIZ_COMPLETE)) {
      const maxPoints = Object.values(this.props.quiz.questions).filter(
        // Don't count free_text questions since they give no points
        item => item["question-meta"].free_text
      ).length;
      const { auth, firebase } = this.props;
      const isSignedIn =
        auth.isLoaded &&
        !auth.isEmpty &&
        firebase.auth().currentUser &&
        !firebase.auth().currentUser.isAnonymous;

      return (
        <CaQuizResult
          header={this.props.t("result_headline")}
          shareHeader={this.props.t("share_header")}
          scoreText={this.props.t("score_headline")}
          points={quizSelectors.getPointsForCurrentQuiz(
            this.props.result,
            this.props.quiz
          )}
          maxPoints={maxPoints}
          shareUrl={quizHelper.getSharedUrlForResult(
            this.props.result,
            this.props.quiz
          )}
          shareTitle={quizHelper.getSharedTitle(
            this.props.result,
            this.props.quiz
          )}
          content={this.getResultContent(isSignedIn)}
          isSingleFreeTextQuiz={maxPoints == 0}
          thankYouText={this.props.t("thank_you")}
        />
      );
    }

    if (hasState(state, QUIZ_STARTED)) {
      const currentQuestion = quizSelectors.question(this.props);
      const totalQuestions = dataSelectors.numberOfQuestions(this.props.data);
      const currentQuestionIndex = quizSelectors.questionIndex(this.props.quiz);
      return (
        <div className={"QuizQuestion QuizComponentView"}>
          <div className={"QuizComponentView__content"}>
            <h2 className={"QuizQuestion__header"}>
              {get(this.props, "quiz.post.title.rendered")} (
              {currentQuestionIndex}/{totalQuestions})
            </h2>
            <div className={"QuizQuestion__divider"} />
            <CaTimer timeLeft={this.props.quiz.timeLeft} onTick={this.onTick} />

            <CaQuestion
              key={currentQuestion.id}
              question={currentQuestion}
              onAnswerSet={this.onAnswer.bind(this)}
              freeTextCta={"Submit"}
            />
          </div>
        </div>
      );
    }
  }

  getContainerStyle() {
    if (!get(this.props, "quiz.post.additional_meta.featuredImage.0")) return;
    return {
      backgroundImage:
        "url(" +
        get(this.props, "quiz.post.additional_meta.featuredImage.0") +
        ")"
    };
  }

  render() {
    const { loading } = this.state;
    const { state } = this.props.quiz;

    if (this.props.user === false || this.props.result === false)
      return <div />;

    return (
      <div
        className={"QuizComponent" + (loading ? " QuizComponent--loading" : "")}
        style={this.getContainerStyle()}
      >
        <div className={"QuizComponent__loadOverlay"} />
        {this.getContentByState(state)}
      </div>
    );
  }
}

export default compose(
  connect(
    state => ({
      auth: state.firebase.auth,
      user: getVal(
        state.firebase,
        `data/users/${state.firebase.auth.uid}/`,
        false
      ),
      result: getVal(
        state.firebase,
        `data/quiz/${state.firebase.auth.uid}/`,
        false
      ),
      general: state.firebase.data.general,
      quiz: state.quiz
    }),
    Object.assign({}, actionsQuiz, actionsAccountModal)
  ),
  firebaseConnect((props, store) => [
    `quiz/${store.getState().firebase.auth.uid}`,
    `users/${store.getState().firebase.auth.uid}`,
    `general`
  ])
)(withTranslation("translations")(CaQuizContainer));
